import type { BondProgramType } from "@/lib/brokerBonds";
import { formatPreapprovalMoney } from "@/lib/bondValueDisplay";
import { NOT_PROVIDED } from "@/lib/display";

// BRK-S401 — the account card's "Last fiscal year revenue" row.
//
// The figure is the account's `annualRevenues` — a decimal string on the read,
// ONE value (PMS publishes no per-year history, fiscal year or as-of date, so
// the latest figure is the only figure). Formatted for display only (D-10
// rule 3); the cents are kept when there are any, the `formatPreapprovalMoney`
// rule, because a rounded figure is a changed one.
//
// An ABSENCE IS NEVER $0. A blank, null or unparseable value is absent, and it
// reads "Available with Signal Advance" for an insured on Signal Express —
// Advance is the program whose connected accounting brings the figure — and
// "— not provided" for everyone else.

export const REVENUE_WITH_ADVANCE = "Available with Signal Advance";

export function lastFiscalYearRevenue(
  annualRevenues: string | null | undefined,
  programType: BondProgramType | null | undefined,
): string {
  const text = typeof annualRevenues === "string" ? annualRevenues.trim() : "";
  // `Number("")` is 0 — the very $0 this row must never invent — so a blank
  // is caught before it is parsed.
  const figure = text === "" ? NaN : Number(text);
  if (Number.isFinite(figure)) return formatPreapprovalMoney(figure);
  return programType === "express" ? REVENUE_WITH_ADVANCE : NOT_PROVIDED;
}
